<app-add-question-button [preview]="preview" action="before" (doAction)="questionAction($event)">
  <div *ngIf="preview" matRipple>
    <app-advanced-properties [model]="model"></app-advanced-properties>
    <div class="question-var-container" (click)="click()">
      <div class="column-flex auto-flex fullWidth">
        <div class="ml-15 auto-flex" *ngIf="model.Banner !== ''">[{{ model.QuestionName }}]</div>
        <div class="auto-flex">
          <diy-player #canvas [show]="show" [model]="previewModel" [showJson]="false" [preview]="true"></diy-player>
        </div>
      </div>
      <div class="question-icon">
        <mat-icon>insert_chart_outlined</mat-icon>
      </div>
    </div>
  </div>
  <div *ngIf="!preview" [formGroup]="maxdiffFormGroup">
    <div formArrayName="maxdiffFormArray">
      <app-advanced-properties [model]="model"></app-advanced-properties>
      <div *ngFor="let opt of questionArr?.controls; let i = index" [formGroupName]="i">
        <div class="question-var-container" (click)="click()">
          <mat-form-field appearance="outline">
            <mat-label>Question Identity</mat-label>
            <input matInput formControlName="qNumber" [patterns]="customPatterns" mask="SA*">
          </mat-form-field>
          <div class="question-icon">
            <div class="question-copy-btn-div">
              <button mat-mini-fab color="accent" matTooltip="Copy Question" (click)="questionAction('copy')"><mat-icon>content_copy</mat-icon></button>
            </div>
            <div>
              <button mat-mini-fab color="accent" matTooltip="Delete Question" (click)="questionAction('delete')"><mat-icon>delete</mat-icon></button>&nbsp;
            </div>
            <div class="question-type-icon-div">
              <mat-icon>insert_chart_outlined</mat-icon>
            </div>
          </div>
        </div>
        <div>
          <diy-editor [channel]="model.Interview.Channel" [questions]="model.Interview.reportableQuestions()" formControlName="banner"></diy-editor>
        </div>
        <div class="wrapFlex margin-top-bot-10">
          <mat-form-field appearance="outline">
            <mat-label> Lowest Label </mat-label>
            <input matInput formControlName="leastInput">
          </mat-form-field>&nbsp;&nbsp;
          <mat-form-field appearance="outline">
            <mat-label> Highest Label </mat-label>
            <input matInput formControlName="mostInput">
          </mat-form-field>&nbsp;&nbsp;
          <mat-form-field appearance="outline">
            <mat-label> No of options per set </mat-label>
            <input type="number" matInput formControlName="optionCountInput">
          </mat-form-field>&nbsp;&nbsp;
          <mat-form-field appearance="outline">
            <mat-label> No of sets per respondent </mat-label>
            <input type="number" matInput formControlName="setCountInput">
          </mat-form-field>
        </div>
        <div class="margin-top-bot-10 display-flex wd-90-per">
          <app-answer-options [model]="model" #options class="fullWidth"></app-answer-options>
        </div>
      </div>
    </div>
  </div>
</app-add-question-button>
